import angular from 'angular';

import { compactRelation } from '../Filters/relationNameFilter';

angular.module('cloudX').directive('cxDashboard', [
  function() {
    return {
      restrict: 'E',
      template: require('./dashboard.html'),
      scope: { data: '=', relation: '=' },
      controller: [
        '$scope',
        '$state',
        '$http',
        '$filter',
        'checkSecurity',
        'invoiceDialogsSvc',
        function($scope, $state, $http, $filter, checkSecurity, invoiceDialogsSvc) {
          $scope.security = {};
          $scope.loading = false;
          $scope.checkSecurity = function(type) {
            if (!$scope.security.hasOwnProperty(type)) $scope.security[type] = checkSecurity(type);
            return $scope.security[type];
          };
          $scope.widgetList = [];
          $scope.$watch('data', function(newValue) {
            if (
              newValue &&
              typeof newValue === 'string' &&
              newValue.toLowerCase().indexOf('/api/') >= 0
            ) {
              $scope.loading = true;
              $http.get(newValue).then(function(response) {
                $scope.widgetList = response.data;
                $scope.loading = false;
              });
            } else {
              $scope.widgetList = newValue;
            }
          });

          $scope.hasAction = function(widget) {
            if (!widget) return false;
            switch (widget.kpi) {
              case 0:
              case 1:
              case 2:
              case 5:
                return $scope.checkSecurity('InvoiceFinal');
              case 3:
                return $scope.checkSecurity('InvoiceDraft');
              case 4:
                return $scope.checkSecurity('RegistrationOthers');
            }
            return false;
          };
          $scope.doAction = function(widget) {
            if (!widget) return;
            const relation = compactRelation($scope.relation);
            switch (widget.kpi) {
              case 0:
                if ($scope.checkSecurity('InvoiceFinal'))
                  $state.go('invoicing.overview', {
                    relation: relation,
                    filterType: widget.status > 0 ? widget.status + 1 : 0,
                  });
                break;
              case 1:
              case 2:
                if ($scope.checkSecurity('InvoiceFinal'))
                  $state.go('invoicing.overview', {
                    relation: relation,
                    filterType: 1,
                  });
                break;
              case 3:
                if ($scope.checkSecurity('InvoiceDraft'))
                  $state.go('invoicing.toInvoice', {
                    relationId: relation.id,
                    relationName: relation.name,
                  });
                break;
              case 4:
                if ($scope.checkSecurity('RegistrationOthers'))
                  $state.go('registrations.overview', {
                    relation: relation,
                    period: 'all',
                    filters: { invoiceStatus: { items: [0] } },
                  });
                break;
              case 5:
                if ($scope.checkSecurity('InvoiceFinal'))
                  invoiceDialogsSvc.showInvoicingHistory(
                    $scope.relation.invoiceStreamId,
                    null,
                    $scope.relation.id,
                  );
                break;
            }
          };
        },
      ],
    };
  },
]);
